import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { accountService, customerService, deviceService } from 'services';


const AppContext = createContext({
  status: null
});

export function AppWrapper({ children }) {
  const [status, setStatus] = useState(null);

  const statusRetriever = useCallback(async (user, customer) => {
    if (customer) {
      console.log("customer");
      const devices = [];
      customer.locations.map(location => {
        location.systems.map(system => {
          devices.push(system.deviceId);
        });
      });
      deviceService.getStatus(devices).then((status) => {
        setStatus(status);
      }
    );
  } else if (user.role <= 2) {
    console.log("no customer");
    const devices = await deviceService.getAll();
    const deviceIds = devices.map(device => device.id);
    deviceService.getStatus(deviceIds).then((status) => {
      setStatus(status);
    });
  }
}, []);

useEffect(() => {
  let statusController;
  let customerSubscription;
  const subscription = accountService.user.subscribe((user) => {
    customerSubscription = customerService.customer.subscribe((customer) => {
      if (user) {
        statusRetriever(user, customer);
        statusController = setInterval(() => {
          statusRetriever(user, customer);
        }, 15000);
      }
      else{
        return () => {
          clearInterval(statusController);
        };
      }
  });
});
  return () => {
    clearInterval(statusController);
    subscription.unsubscribe();
    customerSubscription.unsubscribe();
  };
},[])


  const state = useMemo(() => {
    const s = {
      status
    };

    return s;
  }, [status]);

  return (
    <AppContext.Provider value={state}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}